<template>
<div id="detail-data-card" class="card mt-3 pb-2 shadow-sm">
    <p class="card-header float-left">{{ title }}</p>
    <div class="container">
    <table class="table mb-1 mx-auto text-secondary text-center table-responsive-xl text-nowrap">
        <tbody>
        <tr>
            <th></th>
            <th>{{ player1Name }}</th>
            <th>{{ player2Name }}</th>
        </tr>
        <tr v-for="(dat, idx) in data" :key="idx">
            <td v-if="idx==0">全体</td>
            <td v-else>{{ idx }}ゲーム目</td>
            <td>{{ dat[0] }}</td>
            <td>{{ dat[1] }}</td>
        </tr>
        </tbody>
    </table>
    </div>
</div>
</template>

<script>

export default {
  name: 'detail-data-card',
  props: ['title', 'player1Name', 'player2Name', 'data'],
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/molecules/DetailDataCard.vue